<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <!-- ----------------------------------------------- -->
      <div class="row">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-coin">&nbsp; Manage Expenses</h5>
        </div>
        <div class="col-auto p-0 text-center">
          <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="reloadData()" :disabled="loading">&nbsp; Reload</button>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">

        <div class="col p-0">
          <div class="input-group w-100">
            <span class="input-group-text bi-search"></span>
            <input class="form-control" type="text" placeholder="Search by name" v-model.trim='filter'>
          </div>
        </div>
        
        <div class="col">
          <div class="input-group w-100">
            <span class="input-group-text bi-funnel-fill"></span>
            <select class="form-select" v-model="month" @change="reloadData()">
                <option v-for="x, i in months" :key="i" :value="i">{{ x }}</option>
            </select>
            <select class="form-select" v-model="year" @change="reloadData()">
                <option v-for="x in 10" :key="x">{{ x+2020 }}</option>
            </select>
          </div>

        </div>
        <div class="col-auto p-0">
        </div>
        
        <div class="col p-0">
          <button v-if="$store.getters.access('expense_add')"  class="btn btn-success w-100" @click="showAddExpense()" :disabled="loading">
            <span class="bi-plus-circle">&nbsp; Add Expenses</span>
          </button>
        </div>


      </div>
    </div>
    <!-- =========================================================================================================== -->
    <table class="table table-sm table-bordered table-striped table-hover table-fixed">
      <!-- ----------------------------------------------- -->
      <thead>
        <tr class="table-dark">
          <th class="w-15">Branch</th>
          <th class="w-20">Name</th>
          <th>Details</th>
          <th class="w-15">Date</th>
          <th class="w-15 text-center">Value</th>
          <th class="text-center w-50px"><span class="bi-gear"></span></th>
        </tr>
      </thead>
      <!-- ----------------------------------------------- -->
      <tbody style="height: calc(100vh - 190px)">        
        <tr v-for="expense in expenses_filtered" :key="expense._id">
          <td class="w-15">{{ expense.branch }}</td>
          <td class="w-20">{{ expense.name }}</td>
          <td>{{ expense.details }}</td>
          <td class="w-15">{{ expense.date }}</td>
          <td class="w-15 text-center">{{ formatThousand(expense.value) }}</td>
          <td class="dropstart text-center w-50px">
            <a data-bs-toggle='dropdown' class="btn btn-sm btn-secondary p-1"><span class="bi-three-dots-vertical"></span></a>
            <ul class="dropdown-menu">
              <li v-if="$store.getters.access('expense_edit')"><a class="dropdown-item bi-pencil-fill" @click="showEditExpense(expense)">Edit</a></li>
              <li v-if="$store.getters.access('expense_del')"><a class="dropdown-item bi-trash text-danger" @click="delExpense(expense)">Delete</a></li>
            </ul>
          </td>
        </tr>
      </tbody>
      <!-- ----------------------------------------------- -->
    </table>
    <!-- =========================================================================================================== -->
    <div id="addExpenseModal" ref="addExpenseModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Add New Expense</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Branch</span>
              <select class="form-select" v-model="newExpense.branch">
                <option v-for="x in branches" :key="x._id" :value="x._id">{{ x.name }}</option>
              </select>
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Name</span>
              <input class="form-control" type="text" v-model.trim="newExpense.name">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Details</span>
              <input class="form-control" type="text" v-model.trim="newExpense.details">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Value</span>
              <input class="form-control" type="number" v-model="newExpense.value">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Date</span>
              <input class="form-control" type="date" v-model="newExpense.date">
            </div>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="addExpense()">
                    <span v-if="loading" class="spinner-border"></span>
                    <span>Add</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <div id="editExpenseModal" ref="editExpenseModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Edit Expense: {{ editExpense.nameOriginal }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Branch</span>
              <select class="form-select" v-model="editExpense.branch">
                <option v-for="x in branches" :key="x._id" :value="x._id">{{ x.name }}</option>
              </select>
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Name</span>
              <input class="form-control" type="text" v-model.trim="editExpense.name">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Details</span>
              <input class="form-control" type="text" v-model.trim="editExpense.details">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Value</span>
              <input class="form-control" type="number" v-model="editExpense.value">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Date</span>
              <input class="form-control" type="date" v-model="editExpense.date">
            </div>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="saveExpense()">
                    <span v-if="loading" class="spinner-border"></span>
                    <span>Save</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
  </div>

</template>
<!-- ******************************************************** -->
<script>
  const $ = require('jquery');
  export default {
    name: 'ExpensesPage',
    data(){
      return {
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        loading: false,
        branches: [],
        expenses: [],
        filter: '',
        newExpense:{
          branch: '',
          name: '',
          details: '',
          value: '',
          date: '',
        },
        editExpense:{
          id: '',
          nameOriginal: '',
          branch: '',
          name: '',
          details: '',
          value: '',
          date: '',
        },
      }
    },
    created() {
      this.reloadData();
    },
    mounted(){
    },
    //**********************************************************
    computed:{
      expenses_filtered(){
        let filter = this.filter.toLowerCase();
        return this.expenses.filter((x)=>{
          if(x.name.toLowerCase().includes(filter)) return true;
          if(x.details.toLowerCase().includes(filter)) return true;
          return false;
        });
      }
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async reloadData(){
        this.loading = true;
        this.expenses = [];
        var ack = await this.$service.getExpenses({year: this.year, month: this.month});
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.branches = ack.data.branches;
          this.expenses = ack.data.expenses;
          this.month = ack.data.month;
          this.year = ack.data.year;
        }
        this.loading = false;
      },
      //**********************************************************
      async showAddExpense(){
        $('#addExpenseModal').modal('show');
      },
      //**********************************************************
      async addExpense(){
        this.loading = true;
        await this._addExpense();
        this.loading = false;
      },
      //**********************************************************
      async _addExpense(){
        if(!this.newExpense.branch || !this.newExpense.name || !this.newExpense.details || !this.newExpense.value || !this.newExpense.date){
          return this.$toast('Some Fields are empty', 'warning');
        }
        var ack = await this.$service.addExpense({
          branch: this.newExpense.branch,
          name: this.newExpense.name,
          details: this.newExpense.details,
          value: this.newExpense.value,
          date: this.newExpense.date,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#addExpenseModal').modal('hide');
        this.$toast('Expense Added Successfuly', 'success');
        this.reloadData();
      },
      //**********************************************************
      async showEditExpense(expense){
        this.editExpense.id = expense._id;
        this.editExpense.nameOriginal = expense.name;
        this.editExpense.branch = expense.branchId;
        this.editExpense.name = expense.name;
        this.editExpense.details = expense.details;
        this.editExpense.value = expense.value;
        this.editExpense.date = expense.date;
        $('#editExpenseModal').modal('show');
      },
      //**********************************************************
      async saveExpense(){
        this.loading = true;
        await this._saveExpense();
        this.loading = false;
      },
      //**********************************************************
      async _saveExpense(){
        if(!this.editExpense.branch || !this.editExpense.name || !this.editExpense.details || !this.editExpense.value || !this.editExpense.date){
          return this.$toast('Some Fields are empty', 'warning');
        }
        var ack = await this.$service.editExpense({
          id: this.editExpense.id,
          branch: this.editExpense.branch,
          name: this.editExpense.name,
          details: this.editExpense.details,
          value: this.editExpense.value,
          date: this.editExpense.date,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#editExpenseModal').modal('hide');
        this.$toast('Expense Saved Successfuly', 'success');
        this.reloadData();
      },
      //**********************************************************
      async delExpense(expense){
        var reply = await this.$swal.fire({
          title: "Confirm Delete",
          html: `Are you sure you want to delete the expense <b>${expense.name}</b>`,
          icon: "error", showCancelButton: true, focusCancel: true,
          confirmButtonText: "Confirm Delete", confirmButtonColor: "#d33", 
        });
        if(!reply.isConfirmed) return;
        this.loading = true;
        var ack = await this.$service.delExpense({ id: expense._id });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.$toast('Expense Deleted Successfuly', 'success');
          this.reloadData();
        }
        this.loading = false;
      },
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
</style>
  